
<div class="h-100">
    <c-site-contract-flip-card
        :title    = "$t('contract.lim.title')"
        :contract = "contract"
        :unit     = "unit "
        :edit     = "true"
        @readonly = "onReadonly"
        @store    = "onStore"
    >
        <template v-slot:front>
            <f-title
                v-if   = "isContract"
                class  = "mt-3"
                :title = "$t('contract.terms')"
            />

            <div v-if="isContract">
                <v-row class="no-frame" v-if="contract.type.id === 1">
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label    = "$t('contract.lim.pricePerMonth')"
                            :value = "moneyAsString(contract.pricePerMonth)"
                            color  = "pt-0-5 pl-1 ro-background"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label    = "$t('contract.lim.lgsPerMonth')"
                            :value = "moneyAsString(contract.lgsPerMonth)"
                            color  = "pt-0-5 pl-1 ro-background"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame"  v-if="contract.type && contract.type.id === 2">
                    <c-contract-dls-amounts
                        :readonly = "readonly"
                        :contract = "contract"
                    />
                </v-row>
            </div>

            <f-title
                v-if   = "isContract"
                :title = "$t('contract.billing')"
                class  = "mt-4"
            />

            <div v-if="isContract && isLim">
                <v-row class="no-frame"  >
                    <v-col class="no-frame">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label = "$t('contract.lim.invoiceHandling')"
                            :value = "contract.invoiceHandling.name"
                            filled
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label = "$t('contract.lim.splitMaintenance')"
                            :value = "contract.splitMaintenance"
                            filled
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label = "$t('contract.lim.splitRepair')"
                            :value = "contract.splitRepair"
                            filled
                        />
                    </v-col>
                </v-row>
            </div>

            <f-title
                v-if   = "isContract"
                class  = "mt-2"
                :title = "$t('contract.addresses')"
            />

            <v-row class="no-frame mb-4 pa-2 ro-background " v-if="isContract">
                <div v-if="contract.benefitRecipient" class="w-100">
                    <f-read-only-field
                        class  = "w-100 ro-gap"
                        :label = "$t('contract.recipient.benefit')"
                        :value = "contract.benefitRecipient.name"
                        :dense = "true"
                        color  = "pt-0-5"
                    />

                    <div class="mt-0"></div>
                    <div style="font-size: 13px">
                        {{ contract.benefitRecipient.nameAdd }}
                    </div>
                    <div style="font-size: 13px">
                        {{ contract.benefitRecipient.street }} {{ contract.benefitRecipient.zip }}  {{ contract.benefitRecipient.city }}
                    </div>
                </div>
            </v-row>

            <v-row class="no-frame ro-background pa-2" v-if="isContract">
                <div v-if="contract.invoiceRecipient" class="w-100">
                    <f-read-only-field
                        class  = "w-100 ro-gap"
                        :label = "$t('contract.recipient.invoice')"
                        :value = "contract.invoiceRecipient.name"
                        :dense = "true"
                        color  = "pt-0-5"
                    />

                    <div class="mt-0"></div>
                    <div v-if="contract.invoiceRecipient.nameAdd" style="font-size: 13px">
                        {{ contract.invoiceRecipient.nameAdd }}
                    </div>
                    <div style="font-size: 13px">
                        {{ contract.invoiceRecipient.street }} {{ contract.invoiceRecipient.zip }}  {{ contract.invoiceRecipient.city }}
                    </div>
                </div>
            </v-row>
        </template>
    </c-site-contract-flip-card>
</div>
